<template>
	<div class="drawer" v-if="open">
		<a @click="open = false">CLOSE</a>
		<div class="items">
			<item v-for="item in data.items" :key="item.id" v-bind="item"/>
		</div>
		<div class="total">Total: {{data.total_price / 100}}</div>
	</div>
</template>

<script>
import item from './item.vue';
import store from '../../store';
export default {
	name: "Drawer",
	selector: "#vue-drawer",
	store,
	components: {item},
	computed: {
		data() {
			return this.$store.getters['cart/data'];
		},
		open: {
			get() {
				return this.$store.getters['cart/open'];
			},
			set(open) {
				this.$store.commit('cart/open', open);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.drawer {
	position: fixed;
	top: 0;
	right: 0;
	width: 400px;
	height: 100vh;
	background-color: black;
	color: white;
	padding: 20px;
	.items {
		margin-top: 40px;
	}
}
</style>

